import styled from '@emotion/styled';

import { maxWidthAndCenter, h2 } from '@styles';

const ArticleContainer = styled.article`
  ${maxWidthAndCenter}
  padding: 4rem 0;

  img {
    padding: 2rem 0;
  }

  h1,
  h2 {
    ${h2}
    padding: 0 0 1rem;
    text-align: left;
    color: var(--orange);
    font-size: clamp(2rem, 4vw, 2.25rem);
  }

  h3 {
    padding: 2rem 0 1rem;
    text-transform: uppercase;
    font-weight: 900;
    color: var(--orange);
  }

  p,
  li {
    line-height: 1.5;
    font-size: 1.1rem;
    color: var(--blue);
    margin: 0 0 0.75rem;
  }

  hr {
    border-top-width: 0px;
    border-bottom-width: 4px;
    border-color: var(--blue);
    margin: 2rem 0;
    max-width: 10rem;
  }

  a {
    color: var(--orange);

    &:hover {
      text-decoration: none;
    }

    &:visited {
      color: var(--orange);
    }
  }

  img {
    max-width: 100%;
  }

  @media screen and (max-width: 1470px) {
    padding: 4rem 2rem;
  }
`;

export { ArticleContainer };
